module.exports = __webpack_public_path__ + "static/media/Pre-Orientation-Mini-Golf-20180827-8509.e8f5725f.jpg";